import { useMemo } from "react";
import { MdOutlineComputer } from "react-icons/md";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import type { SessionStatusMap } from "dtos/session.dto";

dayjs.extend(relativeTime);

type SessionBadgeProps = {
  userId: string;
  statusMap: SessionStatusMap | undefined;
  isLoading: boolean;
  onClick: () => void;
};

const getActivityColor = (lastActive: string | null): string => {
  if (!lastActive) return "text-gray-400";

  const diffMinutes = dayjs().diff(dayjs(lastActive), "minute");

  if (diffMinutes < 10) return "text-green-600";
  if (diffMinutes < 30) return "text-orange-500";
  if (diffMinutes < 60) return "text-yellow-600";
  return "text-gray-400";
};

const SessionBadge = ({ userId, statusMap, isLoading, onClick }: SessionBadgeProps) => {
  const status = statusMap?.[userId];
  const lastActive = status?.last_active ?? null;

  const color = useMemo(() => getActivityColor(lastActive), [lastActive]);

  const label = useMemo(() => {
    if (isLoading) return "...";
    if (!lastActive) return "No recent activity";
    return ` ${dayjs(lastActive).fromNow()}`;
  }, [isLoading, lastActive]);

  return (
    <span
      className={`text-xs cursor-pointer inline-flex items-center gap-1 ${color} hover:underline`}
      onClick={onClick}
    >
      <MdOutlineComputer size={12} />
      {label}
    </span>
  );
};

export default SessionBadge;
